import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DashboardComponent} from "./dashboard.component";
import {AuthGuard, CmsConfig, provideConfig} from "@spartacus/core";
import {dashboardOccConfig} from "./_core/dashboard.occ";
import {DashboardService} from "./_core/dashboard.service";
import {ProductCardComponent} from "../product/product-card/product-card.component";
import { RecentBuyItemsComponent } from './recent-buy-items/recent-buy-items.component';
import {CarouselModule} from "primeng/carousel";
import { RecentOrdersComponent } from './recent-orders/recent-orders.component';
import {RouterLink} from "@angular/router";
@NgModule({
  declarations: [DashboardComponent, RecentBuyItemsComponent, RecentOrdersComponent],
  imports: [
    CommonModule,
    ProductCardComponent,
    CarouselModule,
    RouterLink,
  ],
  providers: [
    DashboardService,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        DashboardPageComponent: {
          component: DashboardComponent,
          guards: [AuthGuard],
        },
      },
    }),
    provideConfig(dashboardOccConfig),
    provideConfig({
      routing: {
        routes: {
          dashboardPage: { paths: ['my-account/dashboard'] },
        },
      },
    }),
  ],
})
export class DashboardModule { }
